// Firma táctil sobre canvas. Devuelve dataURL PNG. Ver CLAUDE.md §9/§14.5.
import { useEffect, useRef } from 'react'
import { Button } from './ui/Button'

interface Props {
  onChange: (dataUrl: string | null) => void
}

export function SignaturePad({ onChange }: Props) {
  const canvasRef = useRef<HTMLCanvasElement>(null)
  const drawing = useRef(false)
  const dirty = useRef(false)

  useEffect(() => {
    const canvas = canvasRef.current!
    const ctx = canvas.getContext('2d')!
    ctx.lineWidth = 2
    ctx.lineCap = 'round'
    ctx.strokeStyle = '#1a1a1a'

    const pos = (e: PointerEvent) => {
      const r = canvas.getBoundingClientRect()
      // Escala las coordenadas al tamaño interno del canvas (se muestra más ancho
      // que 400px en móvil, por eso hay que reescalar o la firma se descuadra).
      return {
        x: (e.clientX - r.left) * (canvas.width / r.width),
        y: (e.clientY - r.top) * (canvas.height / r.height),
      }
    }
    const down = (e: PointerEvent) => {
      drawing.current = true
      const p = pos(e)
      ctx.beginPath()
      ctx.moveTo(p.x, p.y)
    }
    const move = (e: PointerEvent) => {
      if (!drawing.current) return
      const p = pos(e)
      ctx.lineTo(p.x, p.y)
      ctx.stroke()
      dirty.current = true
    }
    const up = () => {
      drawing.current = false
      if (dirty.current) onChange(canvas.toDataURL('image/png'))
    }
    canvas.addEventListener('pointerdown', down)
    canvas.addEventListener('pointermove', move)
    window.addEventListener('pointerup', up)
    return () => {
      canvas.removeEventListener('pointerdown', down)
      canvas.removeEventListener('pointermove', move)
      window.removeEventListener('pointerup', up)
    }
  }, [onChange])

  const clear = () => {
    const canvas = canvasRef.current!
    canvas.getContext('2d')!.clearRect(0, 0, canvas.width, canvas.height)
    dirty.current = false
    onChange(null)
  }

  return (
    <div className="space-y-2">
      <canvas
        ref={canvasRef}
        width={400}
        height={180}
        className="w-full touch-none rounded-lg border border-gray-300 bg-white"
      />
      <Button variant="secondary" onClick={clear}>Limpiar firma</Button>
    </div>
  )
}
